import { LeadTypeIdEnum } from '../../Enums';
import { LeadsPoolViewEnum } from '../../Views/Home/LeadsPool/components/LeadsPoolViewEnum';

export const leadTypes = [
  {
    id: 3,
    name: 'Buyer',
    leadTypeCategoryId: LeadTypeIdEnum.Seeker.leadTypeId,
    unitType: LeadsPoolViewEnum.sales,
    rolesName: 'Sale Agent',
  },
  {
    id: 1,
    name: 'Seller',
    leadTypeCategoryId: LeadTypeIdEnum.Owner.leadTypeId,
    unitType: LeadsPoolViewEnum.sales,
    rolesName: 'Sale Listing Agent',
  },
  {
    id: 4,
    name: 'Tenant',
    leadTypeCategoryId: LeadTypeIdEnum.Seeker.leadTypeId,
    unitType: LeadsPoolViewEnum.lease,
    rolesName: 'Lease Agent',
  },
  {
    id: 2,
    name: 'Landlord',
    leadTypeCategoryId: LeadTypeIdEnum.Owner.leadTypeId,
    unitType: LeadsPoolViewEnum.lease,
    rolesName: 'Lease Listing Agent',
  },
];
